import { OdataFieldBasicOperator } from './OdataFieldBasicOperator';
import { IOdataField } from '../../IOdataField';

export class OdataFieldMinute extends OdataFieldBasicOperator {
  constructor(field: IOdataField) {
    super(field, 'minute');
  }
}
